import React from 'react';
import { format } from 'date-fns';
import { useSelector, useDispatch } from 'react-redux';
import { parseISO } from 'date-fns';
import { useTranslation } from 'react-i18next';

import { actions as calendarActions, getModuleState } from 'services/calendar';
import { meetingTypesData } from 'lib/enums/meetingTypes';

import {
  SContainer,
  STime,
  STitle,
  SAbsence,
  SUserName,
  SNote,
} from 'components/Calendar/styled/eventMonth';

import { Box as MuiBox } from '@mui/material';
import { Videocam as VideocamIcon } from '@mui/icons-material';
import { useStatusObject } from 'pages/SchedulePage/utils/statusObject';
import { eventUserStatuses } from 'lib/enums/eventUserStatuses';

function EventMonth(props) {
  const { event } = props;
  const calendarState = useSelector(getModuleState);
  const dispatch = useDispatch();

  const { selectedEvent } = calendarState;

  const isSelected = selectedEvent.eventId === event.id;
  const statusObject = useStatusObject()

  const { t } = useTranslation();

  const getBackgroundColorForContainer = (event) => {
    return event.status === eventUserStatuses.booked
      ? statusObject.APPROVED.hexBgColor
      : statusObject.AWAITING.hexBgColor;
  };
  
  const getBorderColorForContainer = (event) => {
    return event.status === eventUserStatuses.booked
      ? statusObject.APPROVED.hexColor
      : statusObject.AWAITING.hexColor;
  };

  return (
    <>
      {event?.__typename === 'GqlPractitionerAbsence' ? (
        <SAbsence>
          <STitle>{t('Unavailable')}</STitle>
          <STime>
            {event.startDate && event.endDate
              ? `${format(parseISO(event.startDate), 'HH:mm')} - ${format(
                  parseISO(event.endDate),
                  'HH:mm'
                )}`
              : '-'}
          </STime>
          <SNote>{event?.title}</SNote>
        </SAbsence>
      ) : (
        <SContainer
          isSelected={isSelected}
          // disabled={disabled}
          view="month"
          backgroundColor={getBackgroundColorForContainer(event)}
          borderColor={getBorderColorForContainer(event)}
          onMouseEnter={() => {
            dispatch(
              calendarActions.highlightEvent({
                eventId: event.id,
              })
            );
          }}
          onMouseLeave={() => {
            dispatch(calendarActions.highlightEvent({ eventId: null }));
          }}
        >
          <STime view="month" isSelected={isSelected}>
            <MuiBox display="flex">
              <STitle view="month" isSelected={isSelected}>
                <span>{event?.patientParticipant?.patient?.firstName} </span>
                <span>{event?.patientParticipant?.patient?.lastName}</span>
              </STitle>

              <MuiBox>
                {event?.isOnline ? (
                  <VideocamIcon
                    style={{ width: 16, height: 16, marginLeft: 5 }}
                  />
                ) : (
                  ''
                )}
              </MuiBox>
            </MuiBox>

            <SUserName isAppointment={true} isSelected={isSelected}>
              {t(meetingTypesData[event?.eventType]?.label)}
            </SUserName>

            <MuiBox
              style={{
                fontWeight: 600,
                fontSize: 8,
                lineHeight: '11px',
              }}
            >
              {event.startDate && event.endDate
                ? `${format(parseISO(event.startDate), 'HH:mm')} - ${format(
                    parseISO(event.endDate),
                    'HH:mm'
                  )}`
                : '-'}
            </MuiBox>
          </STime>
        </SContainer>
      )}
    </>
  );
}

export default EventMonth;
